module.exports = __webpack_public_path__ + "static/service-people-3-b87c49fef3cc95fdd75182f27b02629f.png";